export default __webpack_public_path__ + "static/media/TrendUp.887b8757.svg";